import { ValidationMessages } from "@/types/functions";

const validationDE: ValidationMessages = {
    'min_length': '{field} en az 0:{min} öğe seçili olmalıdır',
    'max_length': '{field} en fazla 0:{max} öğe seçilebilir',
    'multiple': '{field} 0:{multiple} değerinin katı olmalıdır.'
}

export default validationDE
